export type SessionTokenErrorCode =
  | 'CONCURRENCY_CAP'
  | 'DISABLED'
  | 'INVALID_CREDENTIALS'
  | 'STREAM_FAILURE';

export class SessionTokenError extends Error {
  constructor(
    public readonly code: SessionTokenErrorCode,
    message: string,
  ) {
    super(message);
    this.name = 'SessionTokenError';
  }
}

export async function fetchSessionToken(
  apiEndpoint: string,
  institutionId: string,
): Promise<string> {
  const res = await fetch(
    `${apiEndpoint}/api/chat/v1/institution/${encodeURIComponent(institutionId)}/avatar/session-token`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({}),
    },
  );

  const data = (await res.json().catch(() => ({}))) as {
    sessionToken?: string;
    code?: string;
    error?: string;
  };

  if (!res.ok) {
    const code = data.code ?? '';
    if (res.status === 429 || code === 'CONCURRENCY_CAP') {
      throw new SessionTokenError('CONCURRENCY_CAP', data.error ?? 'Concurrency cap reached');
    }
    if (res.status === 403 || code === 'AVATAR_DISABLED') {
      throw new SessionTokenError('DISABLED', data.error ?? 'Avatar disabled');
    }
    if (code === 'INVALID_CREDENTIALS') {
      throw new SessionTokenError('INVALID_CREDENTIALS', data.error ?? 'Invalid credentials');
    }
    throw new SessionTokenError(
      'STREAM_FAILURE',
      data.error ?? `Token request failed: ${res.status}`,
    );
  }

  if (!data.sessionToken) {
    throw new SessionTokenError(
      'STREAM_FAILURE',
      'Avatar session token response missing sessionToken',
    );
  }
  return data.sessionToken;
}
